<script setup>
import { ref, computed } from "vue";
import Width from "@/pages/Index/Width.vue";
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";
import system from '@/assets/images/bg/system.png'
import { useStore } from "vuex";

const store = useStore()

const currentLang = computed(() => store.getters.currentLanguage)

const infoStyle = computed(() => {
	return currentLang.value === 'cn' ? null : { width: '100%' }
})

const blocks = computed(() => {
	return [
		{
			label: 'manufacture.systems.ProductionManagement.title',
			desc: 'manufacture.systems.ProductionManagement.desc',
			icon: 'ProductionManagement'
		},
		{
			label: 'manufacture.systems.ProductionCycle.title',
			desc: 'manufacture.systems.ProductionCycle.desc',
			icon: 'ProductionCycle'
		},
		{
			label: 'manufacture.systems.ManagementCosts.title',
			desc: 'manufacture.systems.ManagementCosts.desc',
			icon: 'ManagementCosts'
		}
	]
})
</script>

<template>
	<div class="system">
		<div class="system__image" v-if="currentLang === 'cn'">
			<img :src="system" style="width: 100%;height: 100%;" />
		</div>
		<Width>
			<div class="system__content">
				
				<div class="system__content__info" :style="infoStyle">
					
					<div class="system__content__info__title">
						{{ $t('manufacture.systems.title') }}
					</div>
					
					<div class="line" />
					
					<div class="info__list">
						<div
							class="info__list__item"
							v-for="(item, index) in blocks"
							:key="index"
						>
							<div>
								<SvgIcon :name="item.icon" class-name="icon" />
							</div>
							<div class="content">
								<div class="content__title">{{ $t(item.label) }}</div>
								<div class="content__desc">{{ $t(item.desc) }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Width>
		<div class="placeholder" style="opacity: 0;" v-if="currentLang === 'cn'">
			<img :src="system" style="width: 80%;height: 80%;" />
		</div>
		<div class="bottom-img" v-if="currentLang === 'cn'">
			<img :src="system" style="width: 100%;height: 100%;" />
		</div>
	</div>
	
</template>

<style scoped lang="less">

.system {
	padding: 72px 0;
	position: relative;
	overflow: hidden;
	
	.bottom-img {
		display: none;
	}
	
	&__image {
		position: absolute;
		//bottom: 0;
	}
	
	.placeholder {
		display: none;
	}
	
	&__content {
		padding-right: 32px;
		display: flex;
		justify-content: flex-end;
		
		&__info {
			width: 45%;
			
			&__title {
				font-size: 48px;
				font-weight: bold;
				background: linear-gradient(283deg, #D1170E 3%, #F46760 100%), linear-gradient(283deg, #DA241B 0%, #F0554D 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				background-clip: text;
				text-fill-color: transparent;
				line-height: 65px;
			}
			
			.line {
				margin-top: 48px;
				width: 100%;
				height: 3px;
				background: linear-gradient(270deg, rgba(244, 103, 96, 0) 2%, #D1170E 100%);
			}
			
			.info__list {
				margin-top: 48px;
				
				&__item {
					display: flex;
					align-items: start;
					margin-bottom: 32px;
					
					&:last-child {
						margin-bottom: 0;
					}
					
					.icon {
						width: 64px;
						height: 64px;
					}
					
					.content {
						margin-left: 32px;
						
						&__title {
							font-size: 24px;
							font-weight: bold;
							color: #303133;
							margin-bottom: 8px;
						}
						
						&__desc {
							font-size: 18px;
							color: #606266;
							line-height: 24px;
						}
					}
				}
				
			}
		}
	}
}

@media only screen and (max-width: 1400px) {
	.system {
		
		&__image {
			left: -200px;
			transform: scale(.8);
		}
	}
}

@media only screen and (max-width: 1024px) {
	.system {
		padding: 30px 0;
		
		&__image {
			left: -300px;
			bottom: -300px;
			transform: scale(.7);
		}
		
		&__content {
			padding-right: 0;
			
			&__info {
				
				&__title {
					font-size: 24px;
					line-height: 32px;
				}
				
				.line {
					margin-top: 24px;
				}
				
				.info__list {
					margin-top: 24px;
					
					&__item {
					
					}
				}
			}
		}
	}
}

@media only screen and (max-width: 768px) {
	
	.system {
		
		&__image {
			display: none;
			left: -40%;
			bottom: -80%;
			transform: scale(.8);
		}
		
		.placeholder {
			display: block;
		}
		
		.bottom-img {
			position: absolute;
			display: block;
			bottom: -80px;
		}
		
		&__content {
			
			&__info {
				width: 100%;
				&__title {
					font-size: 24px;
					line-height: 30px;
				}
				
				.line {
					margin-top: 16px;
				}
				
				.info__list {
					margin-top: 16px;
					
					&__item {
						margin-bottom: 16px;
						
						.icon {
							width: 48px;
							height: 48px;
						}
						
						.content {
							margin-left: 24px;
							
							&__title {
								font-size: 18px;
								margin-bottom: 8px;
							}
							
							&__desc {
								font-size: 16px;
								line-height: 24px;
							}
							
						}
					}
				}
			}
		}
	}
}
</style>